/*
 * Copyright 2026 North Carolina State University
 */

const TIMEOUT_DURATION = 2 * 60 * 60 * 1000; // 2 hours
let timeoutId;
let warningTimeoutId;

export const setupSessionTimeout = (logout) => {
  clearTimeout(timeoutId);
  clearTimeout(warningTimeoutId);
  
  // Set warning 5 minutes before timeout
  warningTimeoutId = setTimeout(() => {
    alert("Your session will expire in 5 minutes. Please save your work.");
  }, TIMEOUT_DURATION - 5 * 60 * 1000);
  
  timeoutId = setTimeout(() => {
    alert("Your session has expired. Please log in again.");
    logout();
  }, TIMEOUT_DURATION);
};

export const resetSessionTimeout = (logout) => {
  clearTimeout(timeoutId);
  clearTimeout(warningTimeoutId);
  setupSessionTimeout(logout);
};

export const clearSessionTimeout = () => {
  clearTimeout(timeoutId);
  clearTimeout(warningTimeoutId);
};

const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'];

export const setupActivityListeners = (logout) => {
  const resetTimeout = () => resetSessionTimeout(logout);
  events.forEach(event => {
    document.addEventListener(event, resetTimeout);
  });

  return () => {
    events.forEach(event => {
      document.removeEventListener(event, resetTimeout);
    });
  };
};
